export default "__VITE_ASSET__6bd1d2ac__"